/* eslint-disable jsx-a11y/no-redundant-roles */
import axios from "axios";
import { Alert } from "../../design-system/components";
import "../../design-system/forms.css";
import { useEffect, useState } from "react";
import Distancepopup from "../Distancepopup";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config";
import AddressAutocomplete from "../../components/Map/AddressAutocomplete";

const Createorder = () => {
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [referenceError, seterror] = useState(null);
  const [getdataid, setgetdataid] = useState(0);
  let userdata = JSON.parse(localStorage.getItem("logindetail"));
  const initialState = {
    company: "",
    customerorderno: "",
    shipmenttype: "Regular",
    loadtype: "",
    loadno: "",
    pickupnote: "",
    customer_id: "",
    salesman: "",
    commodity: [""],
    weight: [""],
    unit: [""],
    package: [""],
    trailortype: "",
    hazmat: "",
    refer: "",
    temprature: "",
    pip: "",
    ctpat: "",
    pickup_from: "",
    pickup_address: "",
    pickupdate: "",
    pickuptime: "",
    appt: "NO",
    pickup_refno: "",
    pickup_desc: "",
    manageTablestops_length: "",
    delivery: "",
    delivery_address: "",
    deliverydate: "",
    deliverytime: "",
    delivery_refno: "",
    dappointment: "",
    delivery_desc: "",
    revitem: [],
    ratemethod: [],
    rate: "",
    ratevalue: "",
    gross_amount: "",
    hst: "",
    hstamount: "",
    cst: "",
    cstamount: "",
    net_amount: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [saveError, setSaveError] = useState("");
  // OCR Logic
  const [ocrFile, setOcrFile] = useState(null);
  const [isOcrLoading, setIsOcrLoading] = useState(false);

  const flattenObject = (obj, prefix = "", res = {}) => {
    for (let key in obj) {
      const value = obj[key];
      const newKey = prefix ? `${prefix}_${key}` : key;

      if (typeof value === "object" && value !== null) {
        flattenObject(value, newKey, res);
      } else {
        res[newKey.toLowerCase()] = String(value);
      }
    }
    return res;
  };

  const handleOcrFileChange = (e) => {
    setOcrFile(e.target.files[0]);
  };

  const handleOcrUpload = async () => {
    if (!ocrFile) {
      toast.error("Please select a file to upload");
      return;
    }
    
    setIsOcrLoading(true);
    
    const ocrData = new FormData();
    ocrData.append("file", ocrFile);
    ocrData.append("module_type", "order");
    ocrData.append("prompt", `Extract the order information into a strict JSON format exactly matching these keys: {"loadno":"Load number","salesman":"Salesman/driver name","customer_id":"Customer name","pickup_from":"Pickup company","pickup_address":"Pickup address","delivery":"Delivery company","delivery_address":"Delivery address","pickupdate":"Pickup date (YYYY-MM-DD)","deliverydate":"Delivery date (YYYY-MM-DD)","rate":"Rate (number only)","gross_amount":"Gross amount (number only)","trailortype":"Trailer type","commodity":"Commodity","weight":"Weight (number only)","unit":"Weight unit (LBS/KGS)"}. Return ONLY JSON.`);

    try {
      const response = await axios.post(
        `${BASE_URL}OCRController/simple_openai_process`,
        ocrData,
        { withCredentials: true }
      );

      if (response.data && response.data.success) {
        let matchCount = 0;
        const gptData = response.data.gpt_response?.structured_json || {};
        const ocrDataRaw = response.data.data || {};
        const flatOCR = flattenObject(ocrDataRaw);

        // --- UNIVERSAL MAPPING SOURCE GENERATION ---
        const combinedSource = { ...flatOCR };

        if (gptData.names) gptData.names.forEach((n, i) => combinedSource[`gpt_name_${i}`] = n);
        if (gptData.addresses) gptData.addresses.forEach((a, i) => combinedSource[`gpt_address_${i}`] = a);
        if (gptData.dates) Object.entries(gptData.dates).forEach(([k, v]) => combinedSource[`gpt_date_${k}`] = v);
        if (gptData.numbers) Object.entries(gptData.numbers).forEach(([k, v]) => combinedSource[`gpt_number_${k}`] = v);
        if (gptData.records?.[0]) {
          Object.entries(gptData.records[0]).forEach(([k, v]) => {
            combinedSource[`rec_${k}`] = String(v);
          });
        }

        const flatGPT = flattenObject(gptData);
        Object.entries(flatGPT).forEach(([k, v]) => {
          combinedSource[`gpt_${k}`] = String(v);
        });

        setFormData((prev) => {
          const updated = { ...prev };
          const sourceKeys = Object.keys(combinedSource);

          const isFieldEmpty = (val) => {
            if (val === null || val === undefined) return true;
            const s = String(val).trim();
            if (s === "") return true;
            if (Array.isArray(val)) return val.length === 0 || (val.length === 1 && String(val[0]).trim() === "");
            return false;
          };

          const getMatch = (synonyms) => {
            const key = sourceKeys.find(k => synonyms.some(s => {
              const kLower = k.toLowerCase();
              const sLower = s.toLowerCase();
              return kLower === sLower || kLower === `gpt_${sLower}` || kLower.includes(sLower);
            }));
            return key ? combinedSource[key] : null;
          };

          // 1. Map Explicit IDs (Customer, Pickup/Delivery Locations)
          const customerVal = getMatch(['customer_id', 'customer', 'client']);
          if (customerVal && isFieldEmpty(updated.customer_id)) {
            const cust = data.customers?.find(c => c.name?.toLowerCase().includes(String(customerVal).toLowerCase()));
            if (cust) { updated.customer_id = cust.id; matchCount++; }
          }

          const pickupLoc = getMatch(['pickup_from', 'shipper', 'origin']);
          if (pickupLoc && isFieldEmpty(updated.pickup_from)) {
            const loc = data.locations?.find(l => l.name?.toLowerCase().includes(String(pickupLoc).toLowerCase()));
            if (loc) { updated.pickup_from = loc.id; matchCount++; }
          }

          const deliveryLoc = getMatch(['delivery', 'consignee', 'destination']);
          if (deliveryLoc && isFieldEmpty(updated.delivery)) {
            const loc = data.locations?.find(l => l.name?.toLowerCase().includes(String(deliveryLoc).toLowerCase()));
            if (loc) { updated.delivery = loc.id; matchCount++; }
          }

          // Format specific units
          const unitVal = getMatch(['unit']);
          if (unitVal && isFieldEmpty(updated.unit)) {
            let uStr = String(unitVal).toUpperCase();
            if (uStr.includes("LBS") || uStr.includes("POUND")) uStr = "Pounds";
            else if (uStr.includes("KGS") || uStr.includes("KILOS")) uStr = "KGs";
            else if (uStr.includes("TON")) uStr = "Tons";
            updated.unit = [uStr];
            matchCount++;
          }

          // 4. Final catch-all & Logic for Arrays/Numbers
          Object.keys(updated).forEach(field => {
            const isDefault = ["No", "Regular", "LTL", "Hazmat", "13", "0"].includes(String(updated[field]));
            if (!isFieldEmpty(updated[field]) && !isDefault && field !== 'loadno') return;

            const val = getMatch([field]);
            if (val) {
              if (Array.isArray(updated[field])) {
                updated[field] = [String(val)];
              } else if (!isNaN(prev[field]) && typeof prev[field] === 'number') {
                updated[field] = String(val).replace(/[^\d.]/g, "");
              } else {
                updated[field] = String(val).substring(0, 300);
              }
              matchCount++;
            }
          });

          if (matchCount > 0) {
            toast.success(`OCR processed successfully. Mapped ${matchCount} details.`);
          } else {
            toast.warning("OCR processed but no matching fields found.");
          }

          return updated;
        });

      } else {
        toast.error("OCR failed or no data found");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error processing OCR");
    } finally {
      setIsOcrLoading(false);
    }
  };


  const [stops, setStops] = useState([]);
  const addStop = () => {
    const newStop = {
      stoptype: "Delivery", // Default value
      location: "", // Default value
    };
    setStops([...stops, newStop]);
  };

  const handleStopChange = (index, field, value) => {
    const updatedStops = [...stops];
    updatedStops[index][field] = value;
    setStops(updatedStops);
  };

  const handleRemoveRow = (index) => {
    setFormData((prev) => {
      const newData = { ...prev };
      newData.commodity = prev.commodity.filter((_, i) => i !== index);
      newData.weight = prev.weight.filter((_, i) => i !== index);
      newData.unit = prev.unit.filter((_, i) => i !== index);
      newData.package = prev.package.filter((_, i) => i !== index);
      return newData;
    });
  };

  const handleAddRow = () => {
    setFormData((prev) => ({
      ...prev,
      commodity: [...prev.commodity, ""],
      weight: [...prev.weight, ""],
      unit: [...prev.unit, ""],
      package: [...prev.package, ""],
    }));
  };
  const [, setmessage] = useState();
  const [popup, setpopup] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "delivery") {
      // Find the selected location based on the value (id)
      const selectedLocation = data.locations.find((item) => item.id === value);

      // Update formData with the new delivery address and delivery id
      setFormData({
        ...formData,
        [name]: value,
        delivery_address: selectedLocation ? selectedLocation.address1 : "",
      });
    } else if (name === "pickup_from") {
      const selectedLocation = data.locations.find((item) => item.id === value);

      // Update formData with the new delivery address and delivery id
      setFormData({
        ...formData,
        [name]: value,
        pickup_address: selectedLocation ? selectedLocation.address1 : "",
      });
    } else {
      // For other input fields
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    // Perform calculations if relevant fields change
    if (["gross_amount", "hst", "cst", "rate", "ratevalue"].includes(name)) {
      calculateAmounts(name, value);
    }
  };

  const calculateAmounts = (name, value) => {
    const rate = parseFloat(name === "rate" ? value : formData.rate) || 0;
    const rateValue =
      parseFloat(name === "ratevalue" ? value : formData.ratevalue) || 0;

    // Calculate gross amount dynamically
    const gross =
      name === "rate" || name === "ratevalue"
        ? rate * rateValue
        : parseFloat(formData.gross_amount) || 0;

    const hst = parseFloat(name === "hst" ? value : formData.hst) || 0;
    const cst = parseFloat(name === "cst" ? value : formData.cst) || 0;

    // Calculate HST and CST amounts
    const hstAmount = (gross * hst) / 100;
    const cstAmount = (gross * cst) / 100;

    // Calculate Net Amount
    const netAmount = gross + hstAmount + cstAmount;

    // Update formData with calculated values
    setFormData((prev) => ({
      ...prev,
      gross_amount: gross.toFixed(2),
      hstamount: hstAmount.toFixed(2),
      cstamount: cstAmount.toFixed(2),
      net_amount: netAmount.toFixed(2),
    }));
  };
  const handleInputChange2 = (e, index, field) => {
    const { value } = e.target;

    setFormData((prevState) => {
      const updatedFormData = { ...prevState };

      // Ensure the array exists in the state
      if (!updatedFormData[field]) {
        updatedFormData[field] = [];
      }

      // Update the value at the specified index
      updatedFormData[field][index] = value;

      return updatedFormData;
    });
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}api/getOrderData`)
      .then((res) => {
        setdata(res.data);
        setFormData(prev => ({ ...prev, customerorderno: res && res.data.orderno }));
        console.log(res.data);
      })
      .catch((error) => seterror(error));
    // eslint-disable-next-line
  }, []);

  let handleonSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!formData.company || !formData.customer_id || !formData.pickup_from || !formData.delivery) {
      toast.error("Please fill in required fields: Company, Customer, Pickup, and Delivery.");
      return;
    }

    setSaveError("");
    setIsSubmitting(true);

    const form = new FormData();
    form.append("userid", userdata.id);
    form.append("company", formData.company);
    form.append("customerorderno", formData.customerorderno);
    form.append("shipmenttype", formData.shipmenttype);
    form.append("loadtype", formData.loadtype);
    form.append("pickupnote", formData.pickupnote);
    form.append("customer_id", formData.customer_id);
    form.append("salesman", formData.salesman);
    form.append("loadno", formData.loadno);
    form.append("commodity[]", formData.commodity);
    form.append("weight[]", formData.weight);
    form.append("unit[]", formData.unit);
    form.append("package[]", formData.package);
    form.append("trailortype", formData.trailortype);
    form.append("hazmat", formData.hazmat);
    form.append("refer", formData.refer);
    form.append("temprature", formData.temprature);
    form.append("pip", formData.pip);
    form.append("ctpat", formData.ctpat);
    form.append("pickup_from", formData.pickup_from);
    form.append("pickup_address", formData.pickup_address);
    form.append("pickupdate", formData.pickupdate);
    form.append("pickuptime", formData.pickuptime);
    form.append("pickup_refno", formData.pickup_refno);
    form.append("appt", formData.appt);
    form.append("pickup_desc", formData.pickup_desc);
    form.append("Location12", JSON.stringify(stops));
    form.append("manageTablestops_length", formData.manageTablestops_length);
    form.append("delivery", formData.delivery);
    form.append("delivery_address", formData.delivery_address);
    form.append("deliverydate", formData.deliverydate);
    form.append("deliverytime", formData.deliverytime);
    form.append("delivery_refno", formData.delivery_refno);
    form.append("dappointment", formData.dappointment);
    form.append("delivery_desc", formData.delivery_desc);
    form.append("revitem[]", formData.revitem);
    form.append("ratemethod[]", formData.ratemethod);
    form.append("rate[]", formData.rate);
    form.append("ratevalue[]", formData.ratevalue);
    form.append("gross_amount", formData.gross_amount);
    form.append("hst", formData.hst);
    form.append("hstamount", formData.hstamount);
    form.append("cst", formData.cst);
    form.append("cstamount", formData.cstamount);
    form.append("net_amount", formData.net_amount);

    try {
      const response = await axios.post(
        `${BASE_URL}api/create`,
        form
      );
      setmessage(response.data.message);
      setmessage(response.data.message);
      setFormData(initialState);

      setgetdataid(response.data.id);
      toast.success("Successfully created", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      navigate(-1);
    } catch (error) {
      setSaveError("The order could not be saved. Your entries are preserved. Check your connection before retrying.");
      toast.error("The order could not be saved. Check your connection and try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

    } finally {
      setIsSubmitting(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps


  return (
    <div className="content-wrapper iso-ui iso-form-workspace" data-iso-theme="light">
      <section className="content-header">
        <h1>
          Create order
          <small>Customer, route and pricing details</small>
        </h1>
        <ol className="breadcrumb">
          <li>
            <Link to="#">
              <i className="fa fa-dashboard" /> Home
            </Link>
          </li>
          <li className="active">Orders</li>
        </ol>
      </section>
      <section className="content">
        {referenceError && <Alert tone="danger" title="Order reference data could not be loaded">Company and customer options may be unavailable. Check your connection and reload this page before saving.</Alert>}
        {/* Small boxes (Stat box) */}
        <div className="row">
          <div className="col-md-12 col-xs-12">

            {/* OCR UPLOAD SECTION */}
            <div className="box box-solid">
              <div className="box-body">
                <div className="form-group">
                  <label htmlFor="order-ocr-document">Upload Document (OCR Auto-fill)</label>
                  <div className="input-group">
                    <input
                      type="file"
                      id="order-ocr-document"
                      aria-describedby="order-ocr-help"
                      className="form-control"
                      onChange={handleOcrFileChange}
                      accept=".pdf,.png,.jpg,.jpeg"
                    />
                    <span className="input-group-btn">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleOcrUpload}
                        disabled={isOcrLoading}
                      >
                        {isOcrLoading ? (
                          <>
                            <i className="fa fa-spinner fa-spin" style={{ marginRight: "5px" }}></i>
                            Processing...
                          </>
                        ) : (
                          "Scan & Auto-fill"
                        )}
                      </button>
                    </span>
                  </div>
                  <p className="help-block" id="order-ocr-help">Upload a PDF or image, then review every extracted field before saving. Company, customer, pickup and delivery are required.</p>
                </div>
              </div>
            </div>
            {/* END OCR UPLOAD SECTION */}
            <div id="messages" />
            <div className="box">
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <h4>
                    <span className="label label-success">
                      CUSTOMER DETAILS
                    </span>
                  </h4>
                  <h3 align="center">Order # : {data && data.orderno}</h3>
                </div>
              </div>
              {/* /.box-header */}
              <form
                role="form"
                action=""
                method="post"
                encType="multipart/form-data"
              >
                <div className="box-body">
                  <div className="col-md-6 col-xs-12 pull pull-left">
                    <div className="col-md-12 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="company">Company</label>
                        <select
                          className="form-control"
                          id="company"
                          name="company"
                          value={formData.company}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Company</option>
                          {data.company_data?.map((item) => (
                            <option value={item.company_name}>
                              {item.company_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <input
                      type="hidden"
                      className="form-control"
                      id="customerorderno"
                      name="customerorderno"
                      value={data && data.triprno}
                    />
                    <div className="col-md-6 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="shipmenttype">Shipment Type</label>
                        <select
                          className="form-control"
                          id="shipmenttype"
                          name="shipmenttype"
                          value={formData.shipmenttype}
                          onChange={handleInputChange}
                        >
                          <option value="Regular">Regular</option>
                          <option value="into Canada">into Canada</option>
                          <option value="into USA">into USA</option>
                          <option value="round">round</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="commission">Commmission</label>
                        <select
                          className="form-control"
                          id="commission"
                          name="commission"
                          value={formData.commission}
                          onChange={handleInputChange}
                        >
                          <option value="Order">Order</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-12 pull pull-right">
                    <div className="col-md-12 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="customer_id">Brokers</label>
                        <select
                          className="form-control"
                          id="customer_id"
                          name="customer_id"
                          value={formData.customer_id}
                          onChange={handleInputChange}
                        >
                          <option value={23}>
                            RELIANCE LOGISTICS GROUP INC.
                          </option>
                          <option value={19}>LOYAL EXPRESS TRANSPORT</option>
                          <option value={18}>META FACEBOOK</option>
                          <option value={17}>BAKERS FIELD</option>
                          <option value={15}>
                            NATIONAL PRODUCE MARKETING INC
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="loadtype">Load Type</label>
                        <select
                          className="form-control"
                          id="loadtype"
                          name="loadtype"
                          value={formData.loadtype}
                          onChange={handleInputChange}
                        >
                          <option> Select Load type</option>
                          <option value="FTL">FTL</option>
                          <option value="LTL">LTL</option>
                          <option value="single">Single </option>
                          <option value="team">Team (Option)</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="frieghton">Frieght on</label>
                        <select
                          className="form-control"
                          id="frieghton"
                          name="frieghton"
                          value={formData.frieghton}
                          onChange={handleInputChange}
                        >
                          <option value="Order">Order</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="salesman">Salesman</label>
                        <select
                          className="form-control"
                          id="salesman"
                          name="salesman"
                          value={formData.salesman}
                          onChange={handleInputChange}
                        >
                          {data.customers?.map((item) => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="scaleticketno">Scale #</label>
                        <input
                          type="text"
                          className="form-control"
                          id="scaleticketno"
                          name="scaleticketno"
                          value={
                            formData.scaleticketno
                              ? formData.scaleticketno
                              : data && data.triprno
                          }
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-3 col-xs-12 pull pull-left">
                      <div className="form-group">
                        <label htmlFor="scaleticketno">Load no #</label>
                        <input
                          type="text"
                          className="form-control"
                          id="scaleticketno"
                          name="scaleticketno"
                          value={
                            formData.loadno
                              ? formData.loadno
                              : data && data.loadno
                          }
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    {/*
          
           <div class="col-md-12 col-xs-12 pull pull-left">
          
          <div class="form-group">
            <label htmlFor="carrier_desc">Description</label>
            <textarea type="text" class="form-control" id="carrier_desc" name="carrier_desc"  autocomplete="off">
                              </textarea>
          </div> 
          </div>
          */}
                  </div>
                </div>
                {/*   
             <div class="col-md-4 col-xs-12 pull pull-left">
              <div class="form-group">
              <label htmlFor="weight">Weight</label>
               <select class="form-control" id="weight" name="weight">
                      
                      <option value="Gallons">Gallons</option>
                      <option value="Grams">Grams</option>
                      <option value="Kilograms">Kilograms</option>
                      <option value="MBF">MBF</option>
                      <option value="Metric Ton">Metric Ton</option>
                      <option value="Ounces">Ounces</option>
                      <option value="Pounds">Pounds</option>
                      <option value="Tons">Tons</option>

              </select>
              </div>
          </div>
          */}
                {/*
              <div class="col-md-3 col-xs-12 pull pull-left">
              <div class="form-group">
              <label htmlFor="measurement">Measurement*</label>
              <select class="form-control" id="measurement" name="measurement">
              <option value="Centimeter">Centimeter</option>
               <option value="Feet">Feet</option>
                <option value="Inches">Inches</option>
                 <option value="Meter">Meter</option>
               
              </select>
              </div>
          </div>
              
             <div class="col-md-3 col-xs-12 pull pull-left">
              
                  <div class="form-group">
                  <label htmlFor="l">L*</label>
                  <input type="text" class="form-control" id="l" name="l"  autocomplete="off">
                  </div>
              
              </div>
                 <div class="col-md-3 col-xs-12 pull pull-left">
              
                  <div class="form-group">
                  <label htmlFor="b">B*</label>
                  <input type="text" class="form-control" id="b" name="b"  autocomplete="off">
                  </div>
              
              </div>
                 <div class="col-md-3 col-xs-12 pull pull-left">
              
                  <div class="form-group">
                  <label htmlFor="h">H*</label>
                  <input type="text" class="form-control" id="h" name="h"  autocomplete="off">
                  </div>
              
              </div>
          
             
              
        
        <!--
          
           <div class="col-md-12 col-xs-12 pull pull-left">
          
          <div class="form-group">
            <label htmlFor="shipment_desc">Description</label>
            <textarea type="text" class="form-control" id="shipment_desc" name="shipment_desc" placeholder="Enter Shipment  Notes" autocomplete="off">
                              </textarea>
          </div> 
          </div>
          */}
              </form>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-right">
              {/*
              <div class="col-md-3 col-xs-12 pull pull-left">
               <label for="store">Pack. Type</label>
              <div class="form-group">
              <input type="text" class="form-control"   name="carr_weight"  list="select-list-id1"/>
              </div>
              <datalist id="select-list-id1">
             
                     
                      <option value="Bag">Bag</option>
                      <option value="Bale">Bale</option>
                      <option value="Barrel">Barrel</option>
                      <option value="Basket">Basket</option>
                      <option value="Bin">Bin</option>
                      <option value="Bing Chest">Bing Chest</option>
                      <option value="Box">Box</option>
                      <option value="Bucket">Bucket</option>
                      <option value="Bundle">Bundle</option>
                      <option value="Can">Can</option>
                      <option value="Can Case">Can Case</option>
                      <option value="Carooy">Carooy</option>
                      <option value="Carcass">Carcass</option>
                      <option value="Carton">Carton</option>
                      <option value="Case">Case</option>
                      <option value="Cask">Cask</option>
                      <option value="Centimeter">Centimeter</option>
                      <option value="Chest">Chest</option>
                      <option value="Coil">Coil</option>
                      <option value="Container Bulk Cargo">Container Bulk Cargo</option>
                      <option value="Cord">Cord</option>
                      <option value="Crate">Crate</option>
                      
                      
                      <option value="Cyilnder">Cyilnder</option>
                      <option value="Drum">Drum</option>
                      <option value="Dry Bulk">Dry Bulk</option>
                      <option value="Feet">Feet</option>
                      <option value="Gallon">Gallon</option>
                      
                      <option value="Hamper">Hamper</option>
                      <option value="Heads of Beef">Heads of Beef</option>
                      <option value="Inches">Inches</option>
                      <option value="Keg">Keg</option>
                      <option value="Lift Van">Lift Van</option>
                      <option value="Liquid Bulk">Liquid Bulk</option>
                      <option value="Logos">Logos</option>
                      <option value="Lugs">Lugs</option>
                      <option value="Meter">Meter</option>
                      <option value="Package">Package</option>
                      <option value="Pail">Pail</option>
                      <option value="Parcel">Parcel</option>
                      <option value="Pieces">Pieces</option>
                      <option value="Private Vehicle">Private Vehicle</option>
                      
                      
                      <option value="Quarters of Beef">Quarters of Beef</option>
                      <option value="Reel">Reel</option>
                      <option value="Roll">Roll</option>
                      <option value="Sack">Sack</option>
                      <option value="Sheet">Sheet</option>
                      <option value="Side of Beef">Side of Beef</option>
                      <option value="Skid">Skid</option>
                      <option value="Tank">Tank</option>
                      <option value="Tin">Tin</option>
                      <option value="Tote Bin">Tote Bin</option>
                      <option value="Truck Load">Truck Load</option>
                      <option value="Tube">Tube</option>
                      <option value="Unit">Unit</option>
                      <option value="Vanpack">Vanpack</option>
                      
                      <option value="Vehicle">Vehicle</option>
                      <option value="Wooden Case">Wooden Case</option>

                                            
                          
                      
              </datalist>
              </div>
              
           */}
            </div>
            <div className="col-md-12 col-xs-12 pull pull-left">
              <div className="form-group">
                <h4>
                  <span className="label label-success">
                    PICKUP/DELIVERY DETAIL
                  </span>
                </h4>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-left">
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="store">
                    Pickup From |{" "}
                    <Link to="/locations/create">Add Location</Link>{" "}
                  </label>
                  <select
                    className="form-control"
                    id="pickup_from"
                    value={formData.pickup_from}
                    onChange={handleInputChange}
                    name="pickup_from"
                  >
                    <option>Select Pickup Location</option>
                    {data.locations?.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <AddressAutocomplete id="pickup_address" name="pickup_address" label="Pickup Address" value={formData.pickup_address} onChange={handleInputChange} />
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <label htmlFor="store">Pickup Date</label>
                <div className="input-group date">
                  <input
                    type="date"
                    name="pickupdate"
                    id="pickupdate"
                    className="form-control"
                    value={formData.pickupdate}
                    onChange={handleInputChange}
                  />
                  <div className="input-group-addon">
                    <span className="glyphicon glyphicon-th" />
                  </div>
                </div>
                <input
                  className="form-control"
                  type="time"
                  id="pickuptime"
                  placeholder="Set Time"
                  name="pickuptime"
                  value={formData.pickuptime}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="pickup_refno">Refrence No.*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="pickup_refno"
                    value={
                      formData.pickup_refno !== undefined
                        ? formData.pickup_refno
                        : data && data.orderno
                          ? data.orderno
                          : "ISV_TRIP-1230"
                    }
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {/* 
              <div class="col-md-6 col-xs-12 pull pull-left">
               <label for="store">Weight</label>
              <div class="form-group">
              <input type="text" class="form-control" placeholder="Search/Select  Values" list="select-list-id"/>
              </div>
              <datalist id="select-list-id">
             
               <option value="Gallons">Gallons</option>
                      <option value="Grams">Grams</option>
                      <option value="Kilograms">Kilograms</option>
                      <option value="MBF">MBF</option>
                      <option value="Metric Ton">Metric Ton</option>
                      <option value="Ounces">Ounces</option>
                      <option value="Pounds">Pounds</option>
                      <option value="Tons">Tons</option>
              </datalist>
              </div> */}
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="pickup_desc">Pickup Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="pickup_desc"
                    name="pickup_desc"
                    placeholder="Enter Pickup Notes"
                    autoComplete="off"
                    value={formData.pickup_desc || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-right">
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="delivery">Deliver To</label>
                  <select
                    className="form-control"
                    id="delivery"
                    name="delivery"
                    value={formData.delivery}
                    onChange={handleInputChange}
                  >
                    <option>Select Drop Location</option>
                    {data.locations?.map((item) => (
                      <option value={item.id}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <AddressAutocomplete id="delivery_address" name="delivery_address" label="Delivery Address" value={formData.delivery_address} onChange={handleInputChange} />
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <label htmlFor="store">Delivery Date</label>
                <div className="input-group date">
                  <input
                    type="date"
                    name="deliverydate"
                    id="deliverydate"
                    className="form-control"
                    value={formData.deliverydate}
                    onChange={handleInputChange}
                  />
                  <div className="input-group-addon">
                    <span className="glyphicon glyphicon-th" />
                  </div>
                </div>
                <input
                  className="form-control"
                  type="time"
                  id="deliverytime"
                  placeholder="Set Time"
                  name="deliverytime"
                  value={formData.deliverytime}
                  onChange={handleInputChange}
                />
              </div>
              <div className="col-md-4 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="delivery_refno">Refrence No.*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="delivery_refno"
                    name="delivery_refno"
                    autoComplete="off"
                    value={
                      formData.delivery_refno
                        ? formData.delivery_refno
                        : data && data.orderno
                    }
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {/* 
              <div class="col-md-6 col-xs-12 pull pull-left">
               <label for="store">Weight</label>
              <div class="form-group">
              <input type="text" class="form-control" placeholder="Search/Select  Values" list="select-list-id"/>
              </div>
              <datalist id="select-list-id">
             
               <option value="Gallons">Gallons</option>
                      <option value="Grams">Grams</option>
                      <option value="Kilograms">Kilograms</option>
                      <option value="MBF">MBF</option>
                      <option value="Metric Ton">Metric Ton</option>
                      <option value="Ounces">Ounces</option>
                      <option value="Pounds">Pounds</option>
                      <option value="Tons">Tons</option>
              </datalist>
              </div> */}
              <div className="col-md-4 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="dappointment">Appointment</label>
                  <select
                    className="form-control"
                    id="dappointment"
                    name="dappointment"
                    value={formData.dappointment}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="delivery_desc">Delivery Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="delivery_desc"
                    name="delivery_desc"
                    placeholder="Enter Delivery Notes"
                    autoComplete="off"
                    value={formData.delivery_desc}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <input
                type="hidden"
                className="form-control"
                id="lat"
                name="lat"
                autoComplete="off"
              />
              <input
                type="hidden"
                className="form-control"
                id="lng"
                name="lng"
                autoComplete="off"
              />
              <input
                type="hidden"
                className="form-control"
                id="source_lat"
                name="source_lat"
                autoComplete="off"
              />
              <input
                type="hidden"
                className="form-control"
                id="source_lng"
                name="source_lng"
                autoComplete="off"
              />
            </div>
            {/*
                      <div class="col-md-2 col-xs-12 pull pull-left">
                      <div class="form-group">
                      <label htmlFor="stoptype">Stop Type</label>
                      <select class="form-control" id="stoptype" name="stoptype">
                      
                      <option value="Delivery">Delivery</option>
                      <option value="Pickup">Pickup</option>
                      </select>
                      </div>
                      </div>
                      
                      
                      <div class="col-md-6 col-xs-12 pull pull-left">
                      <div class="form-group">
                      <label htmlFor="pac-location">Location</label>
                      <input id="pac-location" name="pac-location" type="text" class="form-control" placeholder="Enter Location Name, Address etc." autocomplete="off" />
                      
                      </div>
                      </div>
                    
                 */}
          </div>
          {/* Add Pickup/Delivery Stops Button */}
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-info btn-sm"
                onClick={addStop}
              >
                Add Pickup/Delivery Stops
              </button>
            </div>
          </div>

          {/* Render Stops Dynamically */}
          {stops.map((stop, index) => (
            <div key={index} style={{ marginTop: "15px" }}>
              <div className="form-group">
                <label>Stop Type</label>
                <select
                  className="form-control"
                  value={stop.stoptype}
                  onChange={(e) =>
                    handleStopChange(index, "stoptype", e.target.value)
                  }
                >
                  <option value="Delivery">Delivery</option>
                  <option value="Pickup">Pickup</option>
                </select>
              </div>
              <div className="form-group">
                <label>Location</label>
                <select
                  className="form-control"
                  value={stop.location}
                  onChange={(e) =>
                    handleStopChange(index, "location", e.target.value)
                  }
                >
                  <option value="">Select Location</option>
                  {data.locations?.map((item) => (
                    <option key={item.id} value={item.address1}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          ))}
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div
              id="manageTablestops_wrapper"
              className="dataTables_wrapper form-inline dt-bootstrap no-footer"
            >
              <div className="row">
                <div className="col-sm-6">
                  <div
                    className="dataTables_length"
                    id="manageTablestops_length"
                  >
                    <label>
                      Show{" "}
                      <select
                        name="manageTablestops_length"
                        aria-controls="manageTablestops"
                        className="form-control input-sm"
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>{" "}
                      entries
                    </label>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div
                    id="manageTablestops_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      Search:
                      <input
                        type="search"
                        className="form-control input-sm"
                        placeholder=""
                        aria-controls="manageTablestops"
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <table
                    id="manageTablestops"
                    className="table table-bordered table-striped dataTable no-footer"
                    role="grid"
                    aria-describedby="manageTablestops_info"
                    style={{ width: 1260 }}
                  >
                    <thead>
                      <tr role="row">
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="manageTablestops"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Type: activate to sort column ascending"
                          style={{ width: "494.2px" }}
                        >
                          Type
                        </th>
                        <th
                          className="sorting"
                          tabIndex={0}
                          aria-controls="manageTablestops"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Location: activate to sort column ascending"
                          style={{ width: 669 }}
                        >
                          Location
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="odd">
                        <td
                          valign="top"
                          colSpan={2}
                          className="dataTables_empty"
                        >
                          No data available in table
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-5">
                  <div
                    className="dataTables_info"
                    id="manageTablestops_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing 0 to 0 of 0 entries
                  </div>
                </div>
                <div className="col-sm-7">
                  <div
                    className="dataTables_paginate paging_simple_numbers"
                    id="manageTablestops_paginate"
                  >
                    <ul className="pagination">
                      <li
                        className="paginate_button previous disabled"
                        id="manageTablestops_previous"
                      >
                        <Link
                          to="#"
                          aria-controls="manageTablestops"
                          data-dt-idx={0}
                          tabIndex={0}
                        >
                          Previous
                        </Link>
                      </li>
                      <li
                        className="paginate_button next disabled"
                        id="manageTablestops_next"
                      >
                        <Link
                          to="#"
                          aria-controls="manageTablestops"
                          data-dt-idx={1}
                          tabIndex={0}
                        >
                          Next
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div className="form-group">
              <h4>
                <span className="label label-success">SHIPMENT DETAIL</span>
              </h4>
            </div>
          </div>
          <div className="col-md-12 col-xs-12 pull pull-left">
            <div className="table-responsive">
              <table className="table table-bordered" id="dynamic_weight">
                <tbody>

                  {formData.commodity?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="col-md-12 col-xs-12 pull pull-left">
                          <div className="form-group">
                            <label htmlFor={`commodity-${index}`}>Commodities(s)</label>
                            <input
                              type="text"
                              className="form-control"
                              id={`commodity-${index}`}
                              name={`commodity[${index}]`}
                              placeholder="Enter Commodity"
                              autoComplete="off"
                              value={formData.commodity[index]}
                              onChange={(e) => handleInputChange2(e, index, "commodity")}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="col-md-12 col-xs-12 pull pull-left">
                          <div className="form-group">
                            <label htmlFor={`weight-${index}`}>Weight</label>
                            <input
                              type="text"
                              className="form-control"
                              id={`weight-${index}`}
                              name={`weight[${index}]`}
                              placeholder="Enter Weight"
                              autoComplete="off"
                              value={formData.weight[index]}
                              onChange={(e) => handleInputChange2(e, index, "weight")}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="col-md-12 col-xs-12 pull pull-left">
                          <div className="form-group">
                            <label htmlFor={`unit-${index}`}>Unit</label>
                            <select
                              className="form-control"
                              id={`unit-${index}`}
                              name={`unit[${index}]`}
                              value={formData.unit[index]}
                              onChange={(e) => handleInputChange2(e, index, "unit")}
                            >
                              <option value="na" disabled>
                                Select Unit
                              </option>
                              <option value="Gallons">Gallons</option>
                              <option value="KG">KG</option>
                              <option value="TON">TON</option>
                              <option value="Metric Ton">Metric Ton</option>
                              <option value="Ounces">Ounces</option>
                              <option value="MBF">MBF</option>
                              <option value="Pounds">Pounds</option>
                            </select>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="col-md-12 col-xs-12 pull pull-left">
                          <div className="form-group">
                            <label htmlFor={`package-${index}`}>Packages(s)</label>
                            <input
                              type="text"
                              className="form-control"
                              id={`package-${index}`}
                              name={`package[${index}]`}
                              placeholder="Enter Packages"
                              autoComplete="off"
                              value={formData.package[index]}
                              onChange={(e) => handleInputChange2(e, index, "package")}
                            />
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="col-md-12 col-xs-12 pull pull-left">
                          <div className="form-group">
                            <label>Action</label>
                            {index === formData.commodity.length - 1 ? (
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleAddRow}
                              >
                                +
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveRow(index)}
                              >
                                X
                              </button>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="trailortype">Selecct Trailor Type</label>
                  <select
                    className="form-control"
                    id="trailortype"
                    name="trailortype"
                    value={formData.trailortype}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>
                      Choose Trailor Type
                    </option>
                    {data.trailors?.map((item) => (
                      <option value={item.trailortype}>
                        {item.trailortype}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="manifest">View Manifest</label>
                  <select
                    className="form-control"
                    id="manifest"
                    name="manifest"
                    value={formData.manifest}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="hazmat">Hazmat</label>
                  <select
                    className="form-control"
                    id="hazmat"
                    name="hazmat"
                    value={formData.hazmat}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="addlcharge">Addl. Charges</label>
                  <input
                    type="text"
                    className="form-control"
                    id="addlcharge"
                    name="addlcharge"
                    autoComplete="off"
                    value={formData.addlcharge}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              {/*
               <div class="col-md-2 col-xs-12 pull pull-left">
              <div class="form-group">
              <label htmlFor="refer">Refer</label>
              <select class="form-control" id="refer" name="refer">
             <option value="C">C</option>
                <option value="F">F</option>
               
              </select>
              </div>
          </div>
          */}
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="appt">Delivery by APPT*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="appt"
                    name="appt"
                    autoComplete="off"
                    value={formData.appt}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="pip">PIP</label>
                  <select
                    className="form-control"
                    id="pip"
                    name="pip"
                    value={formData.pip}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3 col-xs-12 pull pull-left">
                <div className="form-group">
                  <label htmlFor="ctpat">CTPAT</label>
                  <select
                    className="form-control"
                    id="ctpat"
                    name="ctpat"
                    value={formData.ctpat}
                    onChange={handleInputChange}
                  >
                    <option value="YES">YES</option>
                    <option value="NO">NO</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-xs-12 pull pull-left">
              <div className="form-group">
                <h4>
                  <span className="label label-success">REVENUE DETAILS</span>
                </h4>
              </div>
            </div>
            <div className="col-md-6 col-xs-12 pull pull-left">
              <div className="table-responsive">
                <label htmlFor="store">Revenue Item | Revenue Method</label>
                <table className="table table-bordered" id="dynamic_field">
                  <tbody>
                    <tr>
                      {/*
              	<td><select name="revitem[]" class="form-control name_list" required >
						     <option value="na" disabled selected>Select Revenue Item</option>
						  <option value="Frieght Charge">Frieght Charge</option>
						  <option value="Fuel Surcharge">Fuel Surcharge</option>
						  </select> </td>	
					
              	<td><select name="ratemethod[]"  class="form-control name_list" required >
              	     <option value="na" disabled selected>Select Rate Type</option>
              	     <option value="Flat">Flat</option>   <option value="RateMile">RateMile</option>    <option value="RateHour">RateHour</option>  <option value="RateItem">RateItem</option>   <option value="Rate/Packages">Rate/Packages</option>   <option value="Rate/Weight">Rate/Weight</option>  <option value="MBF">MBF</option>
						  </select> </td> */}
                      <td>
                        <input
                          type="number"
                          name="rate"
                          placeholder="Enter Rate (0.00)"
                          className="form-control name_list"
                          required=""
                          value={formData.rate}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          name="ratevalue"
                          onKeyUp={() => { }}
                          placeholder="Enter Qty"
                          className="form-control name_list"
                          required=""
                          value={formData.ratevalue}
                          onChange={handleInputChange}
                        />{" "}
                      </td>
                      <td>
                        <button
                          type="button"
                          name="add"
                          id="add"
                          className="btn btn-success"
                        >
                          Add More
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-12 col-xs-12 pull pull-left">
                <table className="table">
                  <tbody>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td />
                      <td>Gross Amount</td>
                      <td className="text-right">
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="gross_amount"
                          name="gross_amount"
                          autoComplete="off"
                          value={formData.gross_amount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td>HST(%)</td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          id="hst"
                          name="hst"
                          autoComplete="off"
                          value={formData.hst}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="hstamount"
                          name="hstamount"
                          autoComplete="off"
                          value={formData.hstamount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td>CST Amount(%)</td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="cst"
                          name="cst"
                          autoComplete="off"
                          value={formData.cst}
                          onChange={handleInputChange}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          id="cstamount"
                          name="cstamount"
                          autoComplete="off"
                          value={formData.cstamount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th scope="row" />
                      <td />
                      <td />
                      <td>Net Amount</td>
                      <td>
                        {" "}
                        <input
                          type="number"
                          className="form-control"
                          id="net_amount"
                          name="net_amount"
                          autoComplete="off"
                          value={formData.net_amount}
                          onChange={handleInputChange}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* /.box-body */}
          {/* /.box-body */}
        </div>
        {/* /.box */}
        <div className="text-center">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setpopup(!popup)}
          >
            Create Estimate
          </button>
          <button onClick={() => navigate(-1)} className="btn btn-warning">
            Back
          </button>
        </div>
      </section >

      {popup && (
        <div
          className="modal fade show"
          role="dialog"
          aria-labelledby="order-save-title"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg" style={{ maxWidth: "90%" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="order-save-title">Review route and save order</h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close order review"
                  onClick={() => setpopup(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ height: "500px", overflow: "auto" }}
              >
                <Distancepopup
                  closePopup={() => setpopup(false)}
                  places1={formData.pickup_address}
                  places2={formData.delivery_address}
                  places3={stops}
                />
              </div>
              <div className="modal-footer">
                {saveError && <Alert tone="danger" title="Order save failed">{saveError} If a request timed out, check the list for an existing record before retrying.</Alert>}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleonSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save Order"}
                </button>
                {getdataid ? (
                  <>
                    <Link
                      to={"/assign/" + getdataid}
                      className="btn btn-success btn-sm"
                    >
                      Assign
                    </Link>
                    <Link
                      target="_blank"
                      to={`https://isovia.ca/fms_api/pdf/invoice_log.php?id=${getdataid}`}
                      className="btn btn-danger btn-xs"
                    >
                      Dispatch
                    </Link>
                  </>
                ) : (
                  <>
                    <button className="btn btn-success btn-sm" disabled>
                      Assign
                    </button>
                    <button className="btn btn-danger btn-xs" disabled>
                      Dispatch
                    </button>
                  </>
                )}

                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => setpopup(false)}
                >
                  Close
                </button>
                {/* Rest of your footer buttons */}
              </div>
            </div>
          </div>
        </div>
      )}
    </div >
  );
};

export default Createorder;
